export function migrateAnonStorage(appId: string, userId: string): void {
  const fromPrefix = `hook:${appId}:_anon:`;
  const toPrefix = `hook:${appId}:${userId}:`;

  try {
    const keysToMigrate: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i);
      if (k && k.startsWith(fromPrefix)) keysToMigrate.push(k);
    }
    for (const fromKey of keysToMigrate) {
      const suffix = fromKey.slice(fromPrefix.length);
      const toKey = toPrefix + suffix;
      const value = localStorage.getItem(fromKey);
      if (value === null) continue;
      // Não sobrescreve se já existe em userId
      if (localStorage.getItem(toKey) === null) {
        localStorage.setItem(toKey, value);
      }
      localStorage.removeItem(fromKey);
    }
  } catch {
    // localStorage indisponível — silent no-op
  }
}
